import { HeaderSearchResult } from "./HeaderSearchResult";
import { SearchInput } from "./SearchInput";

export const HeaderSearch: React.FC = () => {
	return (
		<div className="fixed left-1/2 -translate-x-1/2 overflow-hidden text-brand-blue top-(--header-height) w-full h-[calc(100%-var(--header-height))] lg:h-auto">
			<div className="p-4 lg:p-6 pt-6 shadow-none lg:shadow-inner bg-brand-light-bright">
				<SearchInput />
			</div>
			<HeaderSearchResult />
		</div>
	);
};

// 🔬 TBD
